import React from 'react';
import { FaFacebookF, FaInstagram, FaTwitter, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TopBar2 = ({ branding }) => {
  const { user } = useAuth();

  const phone =
    branding?.phones?.join(" | ") ||
    user?.companyPhone ||
    "+91 0000000000";

  const email =
    branding?.email ||
    user?.companyEmail ||
    "contact@travel.com";

  const facebookUrl =
    branding?.socials?.facebook || "#";

  const instagramUrl =
    branding?.socials?.instagram || "#";

  const twitterUrl =
    branding?.socials?.x || "#";

  const styles = {
    topBarContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: 'var(--topbar-bg-color, #1a1a1a)',
      color: 'var(--topbar-text-color, #e0e0e0)',
      padding: '12px 30px',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      fontSize: '14px',
    },
    section: {
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
    },
    ctaBlock: {
      backgroundColor: 'var(--accent-color, #fecb00)',
      color: '#1a1a1a',
      padding: '8px 20px',
      borderRadius: '20px',
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
    },
    socialLink: {
      color: 'inherit',
      textDecoration: 'none',
      transition: 'color 0.3s ease',
    },
    contactItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      color: 'inherit',
      textDecoration: 'none',
    },
    divider: {
      width: '1px',
      height: '16px',
      backgroundColor: '#555',
    },
  };

  return (
    <div style={styles.topBarContainer}>

      {/* Left Side: Social Media Icons */}
      <div style={styles.section}>
        <a href={facebookUrl} target="_blank" rel="noreferrer" style={styles.socialLink}>
          <FaFacebookF size={16} />
        </a>
        <a href={instagramUrl} target="_blank" rel="noreferrer" style={styles.socialLink}>
          <FaInstagram size={16} />
        </a>
        <a href={twitterUrl} target="_blank" rel="noreferrer" style={styles.socialLink}>
          <FaTwitter size={16} />
        </a>
      </div>

      {/* Center CTA */}
      <div style={styles.ctaBlock}>
        <span>Early Bird Deals End Soon!</span>
      </div>

      {/* Right Side: Contact Info */}
      <div style={styles.section}>
        <a href={`tel:${phone}`} style={styles.contactItem}>
          <FaPhoneAlt size={14} />
          <span>{phone}</span>
        </a>

        <div style={styles.divider}></div>

        <a href={`mailto:${email}`} style={styles.contactItem}>
          <FaEnvelope size={14} />
          <span>{email}</span>
        </a>
      </div>

    </div>
  );
};

export default TopBar2;